import { Box } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineTrash } from 'react-icons/hi';
import colors from '../../../../../../styles/colors';
import { ConfirmPopover } from '../../../../../common/ConfirmPopover/ConfirmPopover';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

export const DeleteQuestion = React.memo(function DeleteQuestion({ id }: { id: string }) {
  const { t } = useTranslation('questionnaireTemplate');
  const removeElement = QuestionnaireTemplateStore.useStoreActions((actions) => actions.removeElement);

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    removeElement(id);
  };

  return (
    <ConfirmPopover message={t('formBuilder.canvas.element.deleteQuestionMessage')} onConfirm={handleDelete}>
      <Box as="button" display="flex" tabIndex={-1}>
        <HiOutlineTrash fontSize={24} color={colors.gray[600]} cursor="pointer" />
      </Box>
    </ConfirmPopover>
  );
});
